import { useSyncExternalStore } from 'react';
import { session, type SessionState } from './session';

export function useSession(): SessionState | null {
  return useSyncExternalStore(session.subscribe, session.get, session.get);
}
